import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { 
  GetAllUsersAction,
  GetUserByIdAction,
  CreateUserAction,
  UpdateUserAction,
  DeleteUserAction,
  BlockUserAction,
  UnblockUserAction,
  GetUserActivityAction,
} from "../../Actions/adminActions";
import { 
  setUsers,
  setSelectedUser,
  setUserActivity,
  setSelectedUserActivity,
  setLoading,
  setError,
  clearError,
  updateUser,
  deleteUser,
} from "../../Reducers/Admin/adminUserManagementReducer";
import { 
  getAllUsers,
  getUserById,
  createUser,
  updateUserService,
  deleteUserService,
  blockUser,
  unblockUser,
  getUserActivity
} from "../../../services/adminUserManagementService";
import { apiResponse } from "../../../helper/helper";
import { toast } from "react-toastify";
import { toastConfiguration } from "../../../Constant/Data";
import { addUser } from "../../Reducers/Admin/adminDashboardReducer";

// Get All Users Saga
function* getAllUsersSaga(action) {
  try {
    console.log("getAllUsersSaga admin action", action?.payload);
    yield put(setLoading(true));
    yield put(clearError());
    
    const response = yield call(getAllUsers, action.payload);
    console.log("adminUserManagementService--------", response);
    if (response.ok) {
      yield put(setUsers({
        users: response?.data?.data || [],
        totalUsers: response.data.pagination?.total || 0,
        totalPages: response.data.pagination?.pages || 1,
        currentPage: response.data.pagination?.page || 1
      }));
    } else {
      yield put(setError(response.message || "Failed to fetch users"));
    }
  } catch (error) {
    console.log("error--------", error);

    yield put(setError(error.message || "Failed to fetch users"));
  } finally {
    yield put(setLoading(false));
  }
}

// Get User By ID Saga
function* getUserByIdSaga(action) {
  try {
    yield put(setLoading(true));
    yield put(clearError());
    
    const response = yield call(getUserById, { userId: action.payload });
    
    if (response.success) {
      yield put(setSelectedUser(response.data));
    } else {
      yield put(setError(response.message || "Failed to fetch user details"));
    }
  } catch (error) {
    yield put(setError(error.message || "Failed to fetch user details"));
  } finally {
    yield put(setLoading(false));
  }
}

// Create User Saga
function* createUserSaga(action) {
  try {
    // yield put(setLoading(true));
    // yield put(clearError());
    
    const response = yield call(createUser, action.payload);
    const {ok,data,originalError}=response||{}
    if (response.ok) {
      // Refresh users list
      yield put(addUser({}));
       toast.success("User Created Successfully",toastConfiguration)
      action?.payload?.action()
    } else {
      const errorMsg = Boolean(typeof data?.message === "string");
      const message = data?.message || originalError?.message;
      if (errorMsg) toast.error(message, toastConfiguration);
      else toast.error(apiResponse(message), toastConfiguration);
    }
  } catch (error) {
    toast.error("Something Went Wrong ", toastConfiguration);

  } finally {
    // yield put(setLoading(false));
  }
}

// Update User Saga
function* updateUserSaga(action) {
  try {
    yield put(setLoading(true));
    yield put(clearError());
    
    const response = yield call(updateUserService, action.payload);
    
    if (response.success) {
      yield put(updateUser(response.data));
    } else {
      yield put(setError(response.message || "Failed to update user"));
    }
  } catch (error) {
    yield put(setError(error.message || "Failed to update user"));
  } finally {
    yield put(setLoading(false));
  }
}

// Delete User Saga
function* deleteUserSaga(action) {
  try {
    yield put(setLoading(true));
    yield put(clearError());
    
    const response = yield call(deleteUserService, { userId: action.payload });
    
    if (response.success) {
      yield put(deleteUser(action.payload));
    } else {
      yield put(setError(response.message || "Failed to delete user"));
    }
  } catch (error) {
    yield put(setError(error.message || "Failed to delete user"));
  } finally {
    yield put(setLoading(false));
  }
}

// Block User Saga
function* blockUserSaga(action) {
  try {
    yield put(setLoading(true));
    yield put(clearError());
    
    const response = yield call(blockUser, { userId: action.payload });
    
    if (response.success) {
      yield put(updateUser({ id: action.payload, status: "blocked" }));
    } else {
      yield put(setError(response.message || "Failed to block user"));
    }
  } catch (error) {
    yield put(setError(error.message || "Failed to block user"));
  } finally {
    yield put(setLoading(false));
  }
}

// Unblock User Saga
function* unblockUserSaga(action) {
  try {
    yield put(setLoading(true));
    yield put(clearError());
    
    const response = yield call(unblockUser, { userId: action.payload });
    
    if (response.success) {
      yield put(updateUser({ id: action.payload, status: "active" }));
    } else {
      yield put(setError(response.message || "Failed to unblock user"));
    }
  } catch (error) {
    yield put(setError(error.message || "Failed to unblock user"));
  } finally {
    yield put(setLoading(false));
  }
}

// Get User Activity Saga
function* getUserActivitySaga(action) {
  try {
    yield put(setLoading(true));
    yield put(clearError());
    
    const response = yield call(getUserActivity, action.payload);
    
    if (response.success) {
      if (action.payload.userId) {
        yield put(setSelectedUserActivity(response.data));
      } else {
        yield put(setUserActivity(response.data));
      }
    } else {
      yield put(setError(response.message || "Failed to fetch user activity"));
    }
  } catch (error) {
    yield put(setError(error.message || "Failed to fetch user activity"));
  } finally {
    yield put(setLoading(false));
  }
}

// Watcher Sagas
export function* watchGetAllUsers() {
  yield takeLatest(GetAllUsersAction.type, getAllUsersSaga);
}

export function* watchGetUserById() {
  yield takeLatest(GetUserByIdAction.type, getUserByIdSaga);
}

export function* watchCreateUser() {
  yield takeLatest(CreateUserAction.type, createUserSaga);
}

export function* watchUpdateUser() {
  yield takeLatest(UpdateUserAction.type, updateUserSaga);
}

export function* watchDeleteUser() {
  yield takeLatest(DeleteUserAction.type, deleteUserSaga);
}

export function* watchBlockUser() {
  yield takeLatest(BlockUserAction.type, blockUserSaga);
}

export function* watchUnblockUser() {
  yield takeLatest(UnblockUserAction.type, unblockUserSaga);
}

export function* watchGetUserActivity() {
  yield takeLatest(GetUserActivityAction.type, getUserActivitySaga);
}
